"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _immutable = require("immutable");
var _Factory = _interopRequireDefault(require("./_Factory.js"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var QuestionBank = /*#__PURE__*/function (_Factory$default) {
  _inherits(QuestionBank, _Factory$default);
  var _super = _createSuper(QuestionBank);
  function QuestionBank() {
    _classCallCheck(this, QuestionBank);
    return _super.apply(this, arguments);
  }
  _createClass(QuestionBank, null, [{
    key: "afterUpdate",
    value: function afterUpdate(record, json) {
      var newRecord = record;
      var attributes = json.attributes;
      if (attributes.psi_board_exam_interface_options) {
        newRecord = newRecord.set('psi_board_exam_interface_options', new _immutable.List(attributes.psi_board_exam_interface_options));
      }
      if (attributes.fred_board_exam_interface_options) {
        newRecord = newRecord.set('fred_board_exam_interface_options', new _immutable.List(attributes.fred_board_exam_interface_options));
      }
      if (attributes.pearson_vue_board_exam_interface_options) {
        newRecord = newRecord.set('pearson_vue_board_exam_interface_options', new _immutable.List(attributes.pearson_vue_board_exam_interface_options));
      }
      if (attributes.cme_product_credits) {
        newRecord = newRecord.set('cme_product_credits', new _immutable.List(attributes.cme_product_credits.map(function (j) {
          return new _immutable.Map(j);
        })));
      }
      return newRecord;
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        name: '',
        state: 'active',
        has_cme: false,
        has_clinical_pearls: false,
        has_trial_pearls: false,
        adaptive_available: false,
        subject_adaptive_available: false,
        occupation: '',
        pass_likelihood_score: 0,
        average_board_exam_response_time_in_seconds: 0,
        minimum_adaptive_questions: 0,
        maximum_adaptive_questions: 0,
        hide_feedback: false,
        count_specifications_rendered: '',
        brief_marketing_blurb: '',
        rounded_question_count: 0,
        vital_prep_question_count: 0,
        vital_prep_rounded_question_count: 0,
        board_info: '',
        show_patient_box: false,
        question_count: 0,
        psi_board_exam_interface_options: new _immutable.List(),
        fred_board_exam_interface_options: new _immutable.List(),
        pearson_vue_board_exam_interface_options: new _immutable.List(),
        peer_score_standard_deviation: 0,
        peer_score_standard_deviation_practice: 0,
        cme_product_id: 0,
        cme_product_price: 0,
        pdp_path: '',
        cme_product_credits: new _immutable.List(),
        peer_rank_threshold: 100,
        ngn_group_minimum_questions: 0,
        ngn_minimum_questions: 0,
        is_ngn: false
      };
    }
  }, {
    key: "hasMany",
    get: function get() {
      return ['adaptive_eligible_subject', 'practice_exam_template'];
    }
  }]);
  return QuestionBank;
}(_Factory.default);
exports.default = QuestionBank;
QuestionBank.jsonType = 'question_bank';